import React from 'react'

export default function ConditionSetting({ color }: { color: string }) {
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_2584_1865)">
        <path d="M16 8.00001L8 16L16 24L24 16L16 8.00001Z" fill={color} />
        <path d="M16 30C15.7264 30.0005 15.4554 29.9469 15.2025 29.8423C14.9497 29.7377 14.7201 29.5842 14.5268 29.3906L2.60936 17.4732C2.21915 17.0822 2 16.5523 2 16C2 15.4476 2.21915 14.9177 2.60936 14.5268L14.5268 2.60936C14.9177 2.21915 15.4476 2 16 2C16.5523 2 17.0822 2.21915 17.4732 2.60936L29.3906 14.5268C29.7808 14.9177 29.9999 15.4476 29.9999 16C29.9999 16.5523 29.7808 17.0822 29.3906 17.4732L17.4732 29.3906C17.2799 29.5842 17.0502 29.7377 16.7974 29.8423C16.5446 29.9469 16.2736 30.0005 16 30ZM16 3.99916C15.9778 3.99919 15.9566 4.00796 15.9409 4.02356L4.02356 15.9409C4.00794 15.9566 3.99917 15.9778 3.99917 16C3.99917 16.0221 4.00794 16.0434 4.02356 16.0591L15.9409 27.9764C15.9566 27.9919 15.9778 28.0006 16 28.0006C16.0221 28.0006 16.0433 27.9919 16.0591 27.9764L27.9764 16.0591C27.992 16.0434 28.0007 16.0221 28.0007 16C28.0007 15.9778 27.992 15.9566 27.9764 15.9409L16.0591 4.02356C16.0433 4.00796 16.0221 3.99919 16 3.99916Z" fill={color} />
      </g>
      <defs>
        <clipPath id="clip0_2584_1865">
          <rect width="32" height="32" fill={color} />
        </clipPath>
      </defs>
    </svg>
  )
}
